import React from "react";
import Layout from "../components/Layout/Layout";
import Withdrawal from "../components/withdrawal/Withdrawal";

const Withdraw = () => {
  return (
    <Layout>
      <Withdrawal />
    </Layout>
  );
};

export default Withdraw;
